var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "form-horizontal" },
      [
        _c(
          "div",
          {
            staticClass: "filter-panel",
            class: {
              "is-sticky": _vm.stickyFilters,
            },
          },
          [
            _c(
              "form",
              {
                staticClass: "flex flex-row search-bar",
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _vm.areaModel === "career"
                  ? _c(
                      "div",
                      { staticClass: "w-full search-bar__input" },
                      [
                        _c("tag-picker", {
                          attrs: {
                            "input-id": "search",
                            current: _vm.selectedNodes,
                            "full-width": true,
                            "with-icon": false,
                            "with-popper": false,
                            "can-add": false,
                            placeholder: _vm.searchPlaceholder,
                            "default-fetch": true,
                          },
                          on: { selected: _vm.handleNodeSelected },
                        }),
                      ],
                      1
                    )
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchModel,
                          expression: "searchModel",
                        },
                      ],
                      staticClass:
                        "form-control our-stars-search search-bar__input",
                      attrs: { placeholder: _vm.searchPlaceholder },
                      domProps: { value: _vm.searchModel },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.searchModel = $event.target.value
                        },
                      },
                    }),
                _vm._v(" "),
                _c("selectize", {
                  staticClass:
                    "selectize selectize-control selectize-single search-bar__input search-bar__select",
                  attrs: {
                    name: "search_area",
                    "disable-delete": true,
                    options: _vm.searchAreaOptions,
                  },
                  model: {
                    value: _vm.areaModel,
                    callback: function ($$v) {
                      _vm.areaModel = $$v
                    },
                    expression: "areaModel",
                  },
                }),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-sm btn-primary flex-shrink-0",
                    attrs: { click: _vm.handleSearchSelected },
                  },
                  [_vm._v("\n          Search\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "filter-row" }, [
              _vm.$vlastMode
                ? _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _c("label", { staticClass: "sr-only" }, [
                        _vm._v("Verification Status"),
                      ]),
                      _vm._v(" "),
                      _c("selectize", {
                        ref: "verification_status",
                        staticClass:
                          "selectize selectize-control selectize-single",
                        attrs: {
                          name: "verification_status",
                          options: _vm.verificationStatusOptions,
                          placeholder: "Verification Status",
                        },
                        on: { input: _vm.getStarsHelper },
                        model: {
                          value: _vm.stateVerificationStatus,
                          callback: function ($$v) {
                            _vm.stateVerificationStatus = $$v
                          },
                          expression: "stateVerificationStatus",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.regionOptions.length > 1,
                      expression: "regionOptions.length > 1",
                    },
                  ],
                  staticClass: "filter-group",
                },
                [
                  _c("label", { staticClass: "sr-only" }, [_vm._v("Region")]),
                  _vm._v(" "),
                  _c("filter-tags", {
                    ref: "region",
                    staticClass:
                      "selectize selectize-multiple selectized our-stars-region",
                    attrs: {
                      name: "region",
                      "key-context": "region",
                      "item-added": _vm.handleAddFlatFilterCallback,
                      "item-removed": _vm.handleRemoveFlatFilterCallback,
                      placeholder: "Region",
                      options: _vm.regionOptions,
                    },
                    on: { input: _vm.getStarsHelper },
                    model: {
                      value: _vm.stateRegion,
                      callback: function ($$v) {
                        _vm.stateRegion = $$v
                      },
                      expression: "stateRegion",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [_vm._v("Based In")]),
                  _vm._v(" "),
                  _c("filter-tags", {
                    ref: "based_in",
                    staticClass: "selectize selectized our-stars-location",
                    class: _vm.$cumulativeSearchEnabled
                      ? "selectize-single"
                      : "selectize-multiple",
                    attrs: {
                      name: "based_in",
                      multiple: !_vm.$cumulativeSearchEnabled,
                      "key-context": "based_in",
                      "item-added": _vm.handleAddFlatFilterCallback,
                      "item-removed": _vm.handleRemoveFlatFilterCallback,
                      "fetch-results": _vm.fetchLocationResultsCallback,
                      "pre-load": true,
                      placeholder: "Based In",
                    },
                    on: { input: _vm.getStarsHelper },
                    model: {
                      value: _vm.stateBasedIn,
                      callback: function ($$v) {
                        _vm.stateBasedIn = $$v
                      },
                      expression: "stateBasedIn",
                    },
                  }),
                  _vm._v(" "),
                  _vm.$cumulativeSearchEnabled
                    ? _c(
                        "a",
                        {
                          staticClass: "pull-right cursor-pointer",
                          on: {
                            click: () => {
                              _vm.handleClearFilter("based_in")
                            },
                          },
                        },
                        [_vm._v("Clear Filter")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.basedInRegionOptions &&
              _vm.basedInRegionOptions.length &&
              _vm.showAll
                ? _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _c("label", { staticClass: "sr-only" }, [
                        _vm._v("Subregion"),
                      ]),
                      _vm._v(" "),
                      _c("filter-tags", {
                        key: "location_region",
                        ref: "location_region",
                        staticClass: "selectize selectized our-stars-location",
                        class: _vm.$cumulativeSearchEnabled
                          ? "selectize-single"
                          : "selectize-multiple",
                        attrs: {
                          name: "location_region",
                          multiple: !_vm.$cumulativeSearchEnabled,
                          "key-context": "location_region",
                          "item-added": _vm.handleAddFlatFilterCallback,
                          "item-removed": _vm.handleRemoveFlatFilterCallback,
                          options: _vm.basedInRegionOptions,
                          placeholder: "Subregion",
                        },
                        on: { input: _vm.getStarsHelper },
                        model: {
                          value: _vm.stateLocationRegionBasedIn,
                          callback: function ($$v) {
                            _vm.stateLocationRegionBasedIn = $$v
                          },
                          expression: "stateLocationRegionBasedIn",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$cumulativeSearchEnabled
                        ? _c(
                            "a",
                            {
                              staticClass: "pull-right cursor-pointer",
                              on: {
                                click: () => {
                                  _vm.handleClearFilter("location_region")
                                },
                              },
                            },
                            [_vm._v("Clear Filter")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.basedInRegionOptions &&
              _vm.basedInRegionOptions.length &&
              !_vm.showAll
                ? _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _c("label", { staticClass: "sr-only" }, [
                        _vm._v("Subregion"),
                      ]),
                      _vm._v(" "),
                      _c("filter-tags", {
                        key: "location_region2",
                        ref: "location_region",
                        staticClass: "selectize selectized our-stars-location",
                        class: _vm.$cumulativeSearchEnabled
                          ? "selectize-single"
                          : "selectize-multiple",
                        attrs: {
                          name: "location_region",
                          multiple: !_vm.$cumulativeSearchEnabled,
                          "key-context": "location_region",
                          "item-added": _vm.handleAddFlatFilterCallback,
                          "item-removed": _vm.handleRemoveFlatFilterCallback,
                          options: _vm.basedInRegionOptions,
                          placeholder: "Subregion",
                        },
                        on: { input: _vm.getStarsHelper },
                        model: {
                          value: _vm.stateLocationRegionBasedIn,
                          callback: function ($$v) {
                            _vm.stateLocationRegionBasedIn = $$v
                          },
                          expression: "stateLocationRegionBasedIn",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$cumulativeSearchEnabled
                        ? _c(
                            "a",
                            {
                              staticClass: "pull-right cursor-pointer",
                              on: {
                                click: () => {
                                  _vm.handleClearFilter("location_region")
                                },
                              },
                            },
                            [_vm._v("Clear Filter")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.$isNflClub && !_vm.$hasTagNodes
                ? _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _c("label", { staticClass: "sr-only" }, [
                        _vm._v("Sport Category"),
                      ]),
                      _vm._v(" "),
                      _c("filter-tags", {
                        ref: "sport",
                        staticClass:
                          "selectize selectize-multiple selectized our-stars-sport",
                        attrs: {
                          name: "sport",
                          "item-added": _vm.handleAddFlatFilterCallback,
                          "item-removed": _vm.handleRemoveFlatFilterCallback,
                          "key-context": "sport",
                          placeholder: _vm.$vlastMode
                            ? _vm.$t("Category")
                            : "Sports",
                          "fetch-results": (term, callback) => {
                            _vm.fetchTagsResultsCallback(
                              term,
                              callback,
                              "sport"
                            )
                          },
                          "fetch-more-results": (term, callback) => {
                            _vm.fetchMoreTagsCallback(term, callback, "sport")
                          },
                          options: _vm.sport,
                        },
                        on: { input: _vm.getStarsHelper },
                        model: {
                          value: _vm.stateSport,
                          callback: function ($$v) {
                            _vm.stateSport = $$v
                          },
                          expression: "stateSport",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$genderModuleEnabled
                ? _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _c("label", { staticClass: "sr-only" }, [
                        _vm._v("Gender"),
                      ]),
                      _vm._v(" "),
                      _c("filter-tags", {
                        ref: "gender",
                        staticClass: "selectize selectized our-stars-gender",
                        class: _vm.$cumulativeSearchEnabled
                          ? "selectize-single"
                          : "selectize-multiple",
                        attrs: {
                          name: "gender",
                          multiple: !_vm.$cumulativeSearchEnabled,
                          "key-context": "gender",
                          "item-added": _vm.handleAddFlatFilterCallback,
                          "item-removed": _vm.handleRemoveFlatFilterCallback,
                          placeholder: "Gender",
                          options: _vm.genderOptions,
                        },
                        on: { input: _vm.getStarsHelper },
                        model: {
                          value: _vm.stateGender,
                          callback: function ($$v) {
                            _vm.stateGender = $$v
                          },
                          expression: "stateGender",
                        },
                      }),
                      _vm._v(" "),
                      _vm.$cumulativeSearchEnabled
                        ? _c(
                            "a",
                            {
                              staticClass: "pull-right cursor-pointer",
                              on: {
                                click: () => {
                                  _vm.handleClearFilter("gender")
                                },
                              },
                            },
                            [_vm._v("Clear Filter")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              (_vm.regionOptions.length <= 1 ||
                !_vm.$genderModuleEnabled ||
                _vm.$hasTagNodes) &&
              !_vm.$hideSocialMediaReferences
                ? _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _c("label", { staticClass: "sr-only" }, [
                        _vm._v("Social Following"),
                      ]),
                      _vm._v(" "),
                      _c("filter-tags", {
                        ref: "social_following",
                        staticClass:
                          "selectize selectize-multiple selectized our-stars-social-following",
                        attrs: {
                          name: "social_following",
                          "key-context": "social_following",
                          "item-added": _vm.handleAddFlatFilterCallback,
                          "item-removed": _vm.handleRemoveFlatFilterCallback,
                          placeholder: "Social Following",
                          options: _vm.social_following,
                        },
                        on: { input: _vm.getStarsHelper },
                        model: {
                          value: _vm.stateSocialFollowing,
                          callback: function ($$v) {
                            _vm.stateSocialFollowing = $$v
                          },
                          expression: "stateSocialFollowing",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.regionOptions.length <= 1 &&
              !_vm.$genderModuleEnabled &&
              !_vm.$hasTagNodes
                ? _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _c("label", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.$t("Club / Event"))),
                      ]),
                      _vm._v(" "),
                      _c("filter-tags", {
                        ref: "club",
                        staticClass:
                          "selectize selectize-multiple selectized our-stars-club",
                        attrs: {
                          name: "club",
                          "item-added": _vm.handleAddFlatFilterCallback,
                          "item-removed": _vm.handleRemoveFlatFilterCallback,
                          "key-context": "club",
                          placeholder: _vm.$t("Club / Event"),
                          options: _vm.club,
                          "fetch-results": (term, callback) => {
                            _vm.fetchTagsResultsCallback(term, callback, "club")
                          },
                          "fetch-more-results": (term, callback) => {
                            _vm.fetchMoreTagsCallback(term, callback, "club")
                          },
                        },
                        on: { input: _vm.getStarsHelper },
                        model: {
                          value: _vm.stateClub,
                          callback: function ($$v) {
                            _vm.stateClub = $$v
                          },
                          expression: "stateClub",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$vlastMode && _vm.$userIsAdmin
                ? _c(
                    "div",
                    { staticClass: "filter-group" },
                    [
                      _c("label", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.$t("organisation name"))),
                      ]),
                      _vm._v(" "),
                      _c("filter-tags", {
                        ref: "client",
                        staticClass: "selectize selectize-multiple selectized",
                        attrs: {
                          name: "client",
                          "key-context": "client",
                          multiple: true,
                          "item-added": _vm.handleAddFlatFilterCallback,
                          "item-removed": _vm.handleRemoveFlatFilterCallback,
                          "pre-load": true,
                          "fetch-results": _vm.fetchClientsCallback,
                          "fetch-more-results": _vm.fetchNextClientsCallback,
                          placeholder: _vm.$options.filters.titleCase(
                            _vm.$t("organisation name")
                          ),
                          options: _vm.clientUsers,
                        },
                        on: { input: _vm.getStarsHelper },
                        model: {
                          value: _vm.stateClient,
                          callback: function ($$v) {
                            _vm.stateClient = $$v
                          },
                          expression: "stateClient",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showAll,
                    expression: "showAll",
                  },
                ],
                staticClass: "filter-row",
                attrs: { id: "collapse-more-options" },
              },
              [
                _vm.regionOptions.length > 1 &&
                _vm.$genderModuleEnabled &&
                !_vm.$hasTagNodes &&
                !_vm.$hideSocialMediaReferences
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Social Following"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "social_following",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-social-following",
                          attrs: {
                            name: "social_following",
                            "key-context": "social_following",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            placeholder: "Social Following",
                            options: _vm.social_following,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateSocialFollowing,
                            callback: function ($$v) {
                              _vm.stateSocialFollowing = $$v
                            },
                            expression: "stateSocialFollowing",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                (_vm.regionOptions.length > 1 || _vm.$genderModuleEnabled) &&
                !_vm.$hasTagNodes
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("Club / Event"))),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "club",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-club",
                          attrs: {
                            name: "club",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "club",
                            placeholder: _vm.$t("Club / Event"),
                            options: _vm.club,
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "club"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(term, callback, "club")
                            },
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateClub,
                            callback: function ($$v) {
                              _vm.stateClub = $$v
                            },
                            expression: "stateClub",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$hasTagNodes
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Industry"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "industry",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-industry",
                          attrs: {
                            name: "industry",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "industry",
                            placeholder: "Industry",
                            options: _vm.industry,
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "industry"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "industry"
                              )
                            },
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateIndustry,
                            callback: function ($$v) {
                              _vm.stateIndustry = $$v
                            },
                            expression: "stateIndustry",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$hasInterestCategories
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Interest Categories"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "interestCategories",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-interestCategories",
                          attrs: {
                            name: "interestCategories",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "interestCategories",
                            placeholder: "Interest Categories",
                            options: _vm.interestCategories,
                            "fetch-results": (term, callback) => {
                              _vm.fetchInterestCategoriesCallback(
                                term,
                                callback
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreInterestCategoriesCallback(
                                term,
                                callback
                              )
                            },
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateInterestCategories,
                            callback: function ($$v) {
                              _vm.stateInterestCategories = $$v
                            },
                            expression: "stateInterestCategories",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$hasInterestCategories
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Specialist Categories"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "specialistTopics",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-specialistTopics",
                          attrs: {
                            name: "specialistTopics",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "specialistTopics",
                            placeholder: "Specialist Categories",
                            options: _vm.specialistTopics,
                            "fetch-results": (term, callback) => {
                              _vm.fetchSpecialistTopicsCallback(term, callback)
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreSpecialistTopicsCallback(
                                term,
                                callback
                              )
                            },
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateSpecialistTopics,
                            callback: function ($$v) {
                              _vm.stateSpecialistTopics = $$v
                            },
                            expression: "stateSpecialistTopics",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$hasPersonalInterests
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Hobbies"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "personalInterests",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-personalInterests",
                          attrs: {
                            name: "personalInterests",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "personalInterests",
                            placeholder: "Hobbies",
                            options: _vm.personalInterests,
                            "fetch-results": (term, callback) => {
                              _vm.fetchPersonalInterestsCallback(term, callback)
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMorePersonalInterestsCallback(
                                term,
                                callback
                              )
                            },
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.statePersonalInterests,
                            callback: function ($$v) {
                              _vm.statePersonalInterests = $$v
                            },
                            expression: "statePersonalInterests",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.$isNflClub
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Available In"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "availableIn",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-location",
                          attrs: {
                            name: "available_in",
                            "key-context": "available_in",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "fetch-results": _vm.fetchLocationResultsCallback,
                            "pre-load": true,
                            placeholder: "Available In",
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateAvailableIn,
                            callback: function ($$v) {
                              _vm.stateAvailableIn = $$v
                            },
                            expression: "stateAvailableIn",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$multipleLeagues
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("League"))),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "league",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-league",
                          attrs: {
                            name: "league",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "league",
                            placeholder: _vm.$t("League"),
                            options: _vm.league,
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "league"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "league"
                              )
                            },
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateLeague,
                            callback: function ($$v) {
                              _vm.stateLeague = $$v
                            },
                            expression: "stateLeague",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-group" },
                  [
                    _c("label", { staticClass: "sr-only" }, [
                      _vm._v("Request Types"),
                    ]),
                    _vm._v(" "),
                    _c("filter-tags", {
                      ref: "opportunity_types",
                      staticClass:
                        "selectize selectize-multiple selectized our-stars-opportunity-types",
                      attrs: {
                        name: "opportunity_types",
                        placeholder: "Request Type",
                        "key-context": "opportunity_types",
                        "item-added": _vm.handleAddFlatFilterCallback,
                        "item-removed": _vm.handleRemoveFlatFilterCallback,
                        "fetch-results": _vm.fetchOpportunityResultsCallback,
                        options: _vm.opportunity_types,
                      },
                      on: { input: _vm.getStarsHelper },
                      model: {
                        value: _vm.stateOpportunityTypes,
                        callback: function ($$v) {
                          _vm.stateOpportunityTypes = $$v
                        },
                        expression: "stateOpportunityTypes",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.$hasTagNodes
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.themeTitle)),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "theme",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-theme",
                          attrs: {
                            name: "theme",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "theme",
                            placeholder: _vm.themeTitle,
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "theme"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(term, callback, "theme")
                            },
                            options: _vm.theme,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateTheme,
                            callback: function ($$v) {
                              _vm.stateTheme = $$v
                            },
                            expression: "stateTheme",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$budgetRangeTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("Budget Range"))),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "budgetRange",
                          staticClass:
                            "selectize selectize-multiple our-stars-budgetRange",
                          attrs: {
                            name: "budgetRange",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "budgetRange",
                            placeholder: _vm.$t("Budget Range"),
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "budgetRange"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "budgetRange"
                              )
                            },
                            options: _vm.budgetRange,
                            sortField: { field: "name", direction: "desc" },
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateBudgetRange,
                            callback: function ($$v) {
                              _vm.stateBudgetRange = $$v
                            },
                            expression: "stateBudgetRange",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$highSchoolTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("High School Attended"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "highSchool",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-highSchool",
                          attrs: {
                            name: "highSchool",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "highSchool",
                            placeholder: "High School Attended",
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "highSchool"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "highSchool"
                              )
                            },
                            options: _vm.highSchool,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateHighSchool,
                            callback: function ($$v) {
                              _vm.stateHighSchool = $$v
                            },
                            expression: "stateHighSchool",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$collegeTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("College Attended"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "college",
                          staticClass:
                            "selectize selectize-multiple our-stars-college",
                          attrs: {
                            name: "college",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "college",
                            placeholder: "College Attended",
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "college"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "college"
                              )
                            },
                            options: _vm.college,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateCollege,
                            callback: function ($$v) {
                              _vm.stateCollege = $$v
                            },
                            expression: "stateCollege",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$degreeCompletedTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Degree Completed"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "degreeCompleted",
                          staticClass:
                            "selectize selectize-multiple our-stars-degreeCompleted",
                          attrs: {
                            multiple: false,
                            name: "degreeCompleted",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "degreeCompleted",
                            placeholder: "Player Completed Degree",
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "degreeCompleted"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "degreeCompleted"
                              )
                            },
                            options: _vm.degreeCompleted,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateDegreeCompleted,
                            callback: function ($$v) {
                              _vm.stateDegreeCompleted = $$v
                            },
                            expression: "stateDegreeCompleted",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$firstContractTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Year Of First Contract"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "firstContract",
                          staticClass:
                            "selectize selectize-control selectize-multiple",
                          attrs: {
                            name: "firstContract",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "firstContract",
                            placeholder: "Year Of First Contract",
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "firstContract"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "firstContract"
                              )
                            },
                            options: _vm.firstContract,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateFirstContract,
                            callback: function ($$v) {
                              _vm.stateFirstContract = $$v
                            },
                            expression: "stateFirstContract",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$positionTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("Position"))),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "position",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-position",
                          attrs: {
                            name: "position",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "position",
                            placeholder: _vm.$t("Position"),
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "position"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "position"
                              )
                            },
                            options: _vm.position,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.statePosition,
                            callback: function ($$v) {
                              _vm.statePosition = $$v
                            },
                            expression: "statePosition",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$awardTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("Awards"))),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "award",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-award",
                          attrs: {
                            name: "award",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "award",
                            placeholder: _vm.$t("Awards"),
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "award"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(term, callback, "award")
                            },
                            options: _vm.award,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateAward,
                            callback: function ($$v) {
                              _vm.stateAward = $$v
                            },
                            expression: "stateAward",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$proBowlTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Have You Ever Made To a Pro Bowl"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "proBowl",
                          staticClass:
                            "selectize selectize-multiple our-stars-proBowl",
                          attrs: {
                            multiple: false,
                            name: "proBowl",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "proBowl",
                            placeholder: "Pro Bowl",
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "proBowl"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "proBowl"
                              )
                            },
                            options: _vm.proBowl,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateProBowl,
                            callback: function ($$v) {
                              _vm.stateProBowl = $$v
                            },
                            expression: "stateProBowl",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$charityTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("Charity Partners"))),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "charity",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-charity",
                          attrs: {
                            name: "charity",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "charity",
                            placeholder: _vm.$t("Charity Partners"),
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "charity"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "charity"
                              )
                            },
                            options: _vm.charity,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateCharity,
                            callback: function ($$v) {
                              _vm.stateCharity = $$v
                            },
                            expression: "stateCharity",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$brandTags
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.$t("Brand Partners"))),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "sponsor",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-charity",
                          attrs: {
                            name: "sponsor",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "sponsor",
                            placeholder: _vm.$t("Brand Partners"),
                            "fetch-results": (term, callback) => {
                              _vm.fetchTagsResultsCallback(
                                term,
                                callback,
                                "sponsor"
                              )
                            },
                            "fetch-more-results": (term, callback) => {
                              _vm.fetchMoreTagsCallback(
                                term,
                                callback,
                                "sponsor"
                              )
                            },
                            options: _vm.sponsor,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateSponsor,
                            callback: function ($$v) {
                              _vm.stateSponsor = $$v
                            },
                            expression: "stateSponsor",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$retired
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("selectize", {
                          ref: "retired",
                          staticClass:
                            "selectize selectize-control selectize-single",
                          attrs: {
                            name: "retired",
                            options: _vm.retiredOptions,
                            placeholder: "Career Status",
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateRetired,
                            callback: function ($$v) {
                              _vm.stateRetired = $$v
                            },
                            expression: "stateRetired",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin && !_vm.$vlastMode
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("label", { staticClass: "sr-only" }, [
                          _vm._v("Packages"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "packages",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-packages",
                          attrs: {
                            name: "packages",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "packages",
                            placeholder: "Packages",
                            "fetch-results": _vm.fetchPackagesResultsCallback,
                            options: _vm.packages,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.statePackages,
                            callback: function ($$v) {
                              _vm.statePackages = $$v
                            },
                            expression: "statePackages",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("selectize", {
                          staticClass:
                            "selectize selectize-control selectize-single",
                          attrs: {
                            name: "search_area",
                            "disable-delete": true,
                            options: _vm.managerOptions,
                            placeholder: "Management",
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateManager,
                            callback: function ($$v) {
                              _vm.stateManager = $$v
                            },
                            expression: "stateManager",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$talentDateOfBirthEnabled
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("selectize", {
                          staticClass:
                            "selectize selectize-control selectize-single",
                          attrs: {
                            name: "age",
                            options: _vm.ageOptions,
                            placeholder: "Age",
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateAge,
                            callback: function ($$v) {
                              _vm.stateAge = $$v
                            },
                            expression: "stateAge",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin && !_vm.$vlastMode
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("selectize", {
                          staticClass:
                            "selectize selectize-control selectize-single",
                          attrs: {
                            name: "visiblity",
                            options: _vm.visibilityOptions,
                            placeholder: "Visibility",
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateVisibility,
                            callback: function ($$v) {
                              _vm.stateVisibility = $$v
                            },
                            expression: "stateVisibility",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin
                  ? _c("div", { staticClass: "filter-group" }, [
                      _c(
                        "div",
                        { staticClass: "radio radio-override radio-primary" },
                        [
                          _c("div", { staticClass: "radio-item" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.stateApp,
                                  expression: "stateApp",
                                },
                              ],
                              attrs: { type: "radio", id: "all", value: "all" },
                              domProps: {
                                checked: _vm._q(_vm.stateApp, "all"),
                              },
                              on: {
                                input: _vm.getStarsHelper,
                                change: function ($event) {
                                  _vm.stateApp = "all"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "all" } }, [
                              _vm._v("All"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio-item" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.stateApp,
                                  expression: "stateApp",
                                },
                              ],
                              attrs: { type: "radio", id: "app", value: "app" },
                              domProps: {
                                checked: _vm._q(_vm.stateApp, "app"),
                              },
                              on: {
                                input: _vm.getStarsHelper,
                                change: function ($event) {
                                  _vm.stateApp = "app"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "app" } }, [
                              _vm._v("App Installed"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "radio-item" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.stateApp,
                                  expression: "stateApp",
                                },
                              ],
                              attrs: {
                                type: "radio",
                                id: "no-app",
                                value: "no-app",
                              },
                              domProps: {
                                checked: _vm._q(_vm.stateApp, "no-app"),
                              },
                              on: {
                                input: _vm.getStarsHelper,
                                change: function ($event) {
                                  _vm.stateApp = "no-app"
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "no-app" } }, [
                              _vm._v("No App"),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin && !_vm.$vlastMode
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("filter-tags", {
                          ref: "talentBudgetCategories",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-talentBudgetCategories",
                          attrs: {
                            name: "talentBudgetCategories",
                            placeholder: "Budget Category",
                            "key-context": "talentBudgetCategories",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            sortField: { field: "name", direction: "asc" },
                            options: _vm.talentCategoryOptions,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateTalentBudgetCategories,
                            callback: function ($$v) {
                              _vm.stateTalentBudgetCategories = $$v
                            },
                            expression: "stateTalentBudgetCategories",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$userIsAdmin && !_vm.$vlastMode
                  ? _c(
                      "div",
                      { staticClass: "filter-group" },
                      [
                        _c("filter-tags", {
                          ref: "talentBudgetCategoryRanges",
                          staticClass:
                            "selectize selectize-multiple selectized our-stars-talentBudgetCategoryRanges",
                          attrs: {
                            name: "talentBudgetCategoryRanges",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            "key-context": "talentBudgetCategoryRanges",
                            placeholder: "Budget Range",
                            sortField: { field: "name", direction: "asc" },
                            options: _vm.talentBudgetRangeOptions,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateTalentBudgetCategoryRanges,
                            callback: function ($$v) {
                              _vm.stateTalentBudgetCategoryRanges = $$v
                            },
                            expression: "stateTalentBudgetCategoryRanges",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-end filter-end" }, [
              _c(
                "span",
                {
                  staticClass: "toggle-button",
                  on: { click: _vm.toggleShowAll },
                },
                [
                  _c("i", {
                    staticClass: "fa",
                    class: [_vm.showAll ? "fa-caret-up" : "fa-caret-down"],
                  }),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.showAll ? "Less" : "More") +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.pagination.total) +
                    " " +
                    _vm._s(_vm.$starLabelPlural) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.stateSearchTerms ||
            (_vm.selectedNodes && _vm.selectedNodes.length)
              ? _c(
                  "div",
                  { staticClass: "spacer-x-4 flex flex-wrap align-center" },
                  [
                    _c("div", { staticClass: "margin-r-1" }, [
                      _vm._v("Searching for"),
                    ]),
                    _vm._v(" "),
                    _vm.stateSearchTerms
                      ? _c(
                          "div",
                          {
                            staticClass: "applied-search applied-search--grey",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("sentenceCase")(_vm.stateSearchArea)
                                ) +
                                ": " +
                                _vm._s(_vm.stateSearchTerms) +
                                "\n          "
                            ),
                            _c("i", {
                              staticClass: "fa fa-times",
                              on: {
                                click: () => {
                                  _vm.unselectSearch(_vm.index)
                                },
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.stateSearchTerms &&
                    _vm.selectedNodes &&
                    _vm.selectedNodes.length
                      ? _c("div", { staticClass: "margin-x-1" }, [
                          _vm._v(_vm._s(" and ")),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.selectedNodes, function (node) {
                      return _c(
                        "div",
                        { key: node.id, staticClass: "applied-search" },
                        [
                          _vm._l(node.ancestors, function (ancestor) {
                            return _c("span", { key: ancestor.id }, [
                              _vm._v(_vm._s(ancestor.name) + " >"),
                            ])
                          }),
                          _vm._v(
                            "\n          " + _vm._s(node.name) + "\n          "
                          ),
                          _c("i", {
                            staticClass: "fa fa-times",
                            on: {
                              click: () => {
                                _vm.unselectNode(node)
                              },
                            },
                          }),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "filter-controls" }, [
              _c("div", { staticClass: "button-group" }, [
                _c("div", { staticClass: "button-group__item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-default",
                      attrs: { type: "button" },
                      on: {
                        click: _vm.handleClearAllFilters,
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [_c("span", [_vm._v("Clear Filters")])]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "button-group__item" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-default",
                      on: {
                        click: _vm.handleClearTalentCallback,
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [_vm._v("Clear " + _vm._s(_vm.$starLabelPlural))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex align-center" }, [
                _vm.$showCategoryStats
                  ? _c(
                      "div",
                      {
                        staticClass: "flex",
                        staticStyle: {
                          "align-items": "center",
                          "max-height": "44px",
                          padding: "5px",
                        },
                      },
                      [
                        _c("div", { staticClass: "metric-text text-grey" }, [
                          _vm._v("Metrics for:"),
                        ]),
                        _vm._v(" "),
                        _c("filter-tags", {
                          ref: "category",
                          staticClass:
                            "selectize selectize-single selectized our-stars-categories",
                          attrs: {
                            name: "category",
                            "item-added": _vm.handleAddFlatFilterCallback,
                            "item-removed": _vm.handleRemoveFlatFilterCallback,
                            multiple: false,
                            "key-context": "category",
                            placeholder: "All Categories",
                            "fetch-results": _vm.fetchCategoriesCallback,
                            options: _vm.categories,
                          },
                          on: { input: _vm.getStarsHelper },
                          model: {
                            value: _vm.stateCategoryFilter,
                            callback: function ($$v) {
                              _vm.stateCategoryFilter = $$v
                            },
                            expression: "stateCategoryFilter",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "flex align-center margin-l-2" }, [
                  _c(
                    "div",
                    { staticClass: "metric-text text-grey margin-r-1" },
                    [_vm._v("Completed data by period:")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _c("flatpickr", {
                        ref: "date",
                        staticClass: "form-control",
                        attrs: {
                          config: _vm.flatPickerDateConfig,
                          name: "completed_bookings_default_date_range",
                        },
                        on: { input: _vm.completedBookingDateRangeSelected },
                        model: {
                          value: _vm.completedBookingsDateRange,
                          callback: function ($$v) {
                            _vm.completedBookingsDateRange = $$v
                          },
                          expression: "completedBookingsDateRange",
                        },
                      }),
                      _vm._v(" "),
                      _vm._m(0),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.allowAddAll
                  ? _c("div", { staticClass: "button-group margin-l-1" }, [
                      _c(
                        "div",
                        { staticClass: "button-group__item" },
                        [
                          _c(
                            "ladda-button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              attrs: { click: _vm.handleAddAllTalentCallback },
                            },
                            [_c("span", [_vm._v("Add All")])]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "margin-l-1" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.selectedStars.length) +
                            " " +
                            _vm._s(_vm.$starLabelPlural) +
                            " selected"
                        ),
                      ]),
                    ]),
              ]),
            ]),
            _vm._v(" "),
            _c("hr"),
          ]
        ),
        _vm._v(" "),
        _vm.stateVisibility === "hidden"
          ? _c("info-alert", {
              attrs: {
                type: "warning",
                size: "large",
                message:
                  "Please note these stars are set to hidden and may not wish to be added to this request.",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass: "shortlist-modal-results row notification-talent-list",
            attrs: { id: "talent-list" },
          },
          [
            _vm.haveNoTalent && _vm.notSearching
              ? _c("div", { staticClass: "text-center" }, [
                  _c("h5", [
                    _vm._v(
                      "There are no " +
                        _vm._s(_vm.$starLabelPlural) +
                        ". Try searching to find who you want."
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.haveSearchText
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-sm",
                          attrs: { type: "button" },
                          on: { click: _vm.handleClearAllFilters },
                        },
                        [_vm._v("Clear Search")]
                      )
                    : _vm._e(),
                ])
              : _vm.notSearching
              ? [
                  _vm._t("talent-list", function () {
                    return [
                      _c(
                        "ul",
                        { staticClass: "talent-filter-list" },
                        _vm._l(
                          _vm.talentWithoutExistingProp,
                          function (talent) {
                            return _c("talent-filtering-talent-list-item", {
                              key: talent.id,
                              attrs: {
                                talent: talent,
                                "booking-budget": _vm.bookingBudget,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ]
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "flex flex-row page-buttons" }, [
              _vm.pagination.current_page > 1
                ? _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.handleGetPageStarsCallback(1)
                        },
                      },
                    },
                    [_vm._v("\n          «\n        ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pagination.current_page > 2
                ? _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.handleGetPageStarsCallback(
                            _vm.pagination.current_page - 2
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.pagination.current_page - 2) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pagination.current_page > 1
                ? _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.handleGetPageStarsCallback(
                            _vm.pagination.current_page - 1
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.pagination.current_page - 1) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("button", { attrs: { disabled: "" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.pagination.current_page) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _vm.pagination.last_page > _vm.pagination.current_page
                ? _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.handleGetPageStarsCallback(
                            _vm.pagination.current_page + 1
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.pagination.current_page + 1) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pagination.last_page > _vm.pagination.current_page + 1
                ? _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.handleGetPageStarsCallback(
                            _vm.pagination.current_page + 2
                          )
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.pagination.current_page + 2) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pagination.current_page < _vm.pagination.last_page
                ? _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.handleGetPageStarsCallback(
                            _vm.pagination.last_page
                          )
                        },
                      },
                    },
                    [_vm._v("\n          »\n        ")]
                  )
                : _vm._e(),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "input-group-addon",
        staticStyle: { "padding-top": "0", "padding-bottom": "0" },
        attrs: { "data-toggle": "" },
      },
      [_c("i", { staticClass: "fa fa-calendar" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }